import { render, staticRenderFns } from "./ihg.vue?vue&type=template&id=fcb0e37a&scoped=true&lang=pug"
import script from "./ihg.vue?vue&type=script&lang=js"
export * from "./ihg.vue?vue&type=script&lang=js"
import style0 from "./ihg.vue?vue&type=style&index=0&id=fcb0e37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0e37a",
  null
  
)

export default component.exports